import { FC, useState } from 'react';
import { InventoryContext } from 'common/context/inventory/inventory.context';

export interface IComponentProps {
  children: React.ReactNode;
}

export const InventoryProvider: FC<IComponentProps> = ({ children }) => {
  const [isNestedCard, setIsNestedCard] = useState<boolean>(false);
  const [openInventoryCard, setOpenInventoryCard] = useState<boolean>(false);
  const [openInventoryActionCard, setOpenInventoryActionCard] = useState<boolean>(false);
  const [openInventoryTransferCard, setOpenInventoryTransferCard] = useState<boolean>(false);
  const [openInventoryWriteOffCard, setOpenInventoryWriteOffCard] = useState<boolean>(false);
  const [openInventoryAssigneeCard, setOpenInventoryAssigneeCard] = useState<boolean>(false);

  return (
    <InventoryContext.Provider
      value={{
        isNestedCard,
        setIsNestedCard,
        openInventoryCard,
        setOpenInventoryCard,
        openInventoryActionCard,
        setOpenInventoryActionCard,
        openInventoryTransferCard,
        setOpenInventoryTransferCard,
        openInventoryWriteOffCard,
        setOpenInventoryWriteOffCard,
        openInventoryAssigneeCard,
        setOpenInventoryAssigneeCard,
      }}
    >
      {children}
    </InventoryContext.Provider>
  );
};
